import React, { createContext, useContext, useState } from "react";

// Upload Context 創建
const OrderContext = createContext();

// 提供者組件
export const OrderProvider = ({ children }) => {
  const [orderData, setOrderData] = useState({
    case_name: "",
    case_no: "",
    house: ""
  });


  const [orderStatus, setOrderStatus] = useState(""); // 用於管理上傳狀態

  // 提供更新函數，支持局部更新
  const updateOrderData = (fieldOrData, value) => {
    if (typeof fieldOrData === "object") {
      // 更新整個對象
      setOrderData((prev) => ({
        ...prev,
        ...fieldOrData,
      }));
    } else {
      // 單個欄位更新
      setOrderData((prev) => ({
        ...prev,
        [fieldOrData]: value,
      }));
    }
    // console.log(orderData);
  };
  
  return (
    <OrderContext.Provider value={{ 
        orderData, 
        updateOrderData,
        orderStatus, // 確保上傳狀態被傳入
        setOrderStatus, // 確保更新狀態的函數被傳入
         }}>
      {children}
    </OrderContext.Provider>
  );
};

// 自定義 Hook
export const useOrderContext = () => useContext(OrderContext);
